'use client';
import { SWAN_BASE_CDN_URL } from '../constants/domains.js';

let t = {
    vistaprint: {
        'da-DK': 'www.vistaprint.dk',
        'de-AT': 'www.vistaprint.at',
        'de-CH': 'www.vistaprint.ch',
        'de-DE': 'www.vistaprint.de',
        'en-AU': 'www.vistaprint.com.au',
        'en-CA': 'www.vistaprint.ca',
        'en-GB': 'www.vistaprint.co.uk',
        'en-IE': 'www.vistaprint.ie',
        'en-IN': 'www.vistaprint.in',
        'en-NZ': 'www.vistaprint.co.nz',
        'en-SG': 'www.vistaprint.sg',
        'en-US': 'www.vistaprint.com',
        'es-ES': 'www.vistaprint.es',
        'es-US': 'www.vistaprint.com',
        'fi-FI': 'www.vistaprint.fi',
        'fr-BE': 'www.vistaprint.be',
        'fr-CA': 'www.vistaprint.ca',
        'fr-CH': 'www.vistaprint.ch',
        'fr-FR': 'www.vistaprint.fr',
        'it-CH': 'www.vistaprint.ch',
        'it-IT': 'www.vistaprint.it',
        'ja-JP': 'www.vistaprint.jp',
        'nb-NO': 'www.vistaprint.no',
        'nl-BE': 'www.vistaprint.be',
        'nl-NL': 'www.vistaprint.nl',
        'pt-PT': 'www.vistaprint.pt',
        'sv-SE': 'www.vistaprint.se'
    }
};
function getSwanBaseUrl(i, n) {
    if (!i || !n) return SWAN_BASE_CDN_URL;
    let r = t[i.toLowerCase()], [a, s] = n.split('-'), e = `${a.toLowerCase()}-${s.toUpperCase()}`;
    return (null == r ? void 0 : r[e]) ? `https://${r[e]}/swan/` : SWAN_BASE_CDN_URL;
}
getSwanBaseUrl.swanBaseUrlForTenantAndLocales = t;

export { getSwanBaseUrl };
